var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"predictTable",attrs:{"auto-resize":"","highlight-hover-row":"","resizable":"","border":"","size":"mini","cell-class-name":"align-top","loading":_vm.loading,"data":_vm.tableData,"columns":_vm.tableColumns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }